import classnames from 'classnames';

import { STATUS } from '../../constants/status.constant';

import './BaseStatusBar.scss';

export const BaseStatusBar = (props) => {
  const { title, description, statusText, status, registrationOfficerComment } = props;

  const classes = classnames('base-status-bar', `base-status-bar--${statusText}`);
  return (
    <div className={classes} data-testid="status-bar">
      <div className="container">
        <div className="row">
          <div className="col-2" />
          <div className="col-8">
            <p className="copy copy--color-dark copy--bold" data-testid="status-bar-title">
              {title}
            </p>
            <p className="copy copy--color-dark base-status-bar__description">
              {status === STATUS.UPDATE_REQUIRED && registrationOfficerComment
                ? registrationOfficerComment
                : description}
            </p>
          </div>
          <div className="col-2" />
        </div>
      </div>
    </div>
  );
};

export default BaseStatusBar;
